import { Toast, Indicator } from "mint-ui";

export default class utils {
  //里面拿不到this 传入当前this
  //isGoBack 不传则需要华为返回 或者传入fasle  传入true 则不需要
  /*
      date:{
        path:'',
        query:'',//
      }
    */
  static $routPush(_this, date, isGoBack) {
    if (!isGoBack) {
      sessionStorage.setItem("stopRouter", "Y");
    }
    _this.$router.push(date);
  }
  /**
   * 判断字符串是否为空
   * @param str
   * @return {boolean}
   */
  static isNull(str) {
    return str == null || str.length === 0 || str === "";
  }
   /**
   * @desc
   * @param {String|Number} obj
   * @return {Boolean}
   */
   static isNullToast(obj, str) {
    if (this.isNull(obj)) {
      Toast({
        message: str,
        iconClass: "icon icon-error"
      });
      return false;
    }
    return true;
  }
  /**
   * @desc 判断是否为手机号
   * @param {String|Number} str
   * @return {Boolean}
   */
  static isPhoneNum(str) {
    return /^(0|86|17951)?(1[3-9][0-9])[0-9]{8}$/.test(str);
  }
  /**
   * @desc 判断是否为手机号，错误手机号弹框
   * @param {String|Number} str
   * @return {Boolean}
   */
  static isPhoneNumToast(str) {
    if (str == "admin") {
      //admin 不做手机号校验
      return true;
    }
    if (!/^(0|86|17951)?(1[3-9][0-9])[0-9]{8}$/.test(str)) {
      Toast({
        message: "请输入合法的手机号码",
        iconClass: "icon icon-error"
      });
      return false;
    }
    return true;
  }
  /**
     * @desc
     * @param {String|Number} str
     * @return {Boolean}
     */
  static ToastError(str) {
    Toast({
      message: str,
      iconClass: "icon icon-error"
    });
  }
  /**
   * @desc
   * @param {String|Number} str
   * @return {Boolean}
   */
  static ToastSuccess(str,classname) {
    Toast({
      message: str,
      iconClass: "icon icon-success",
      duration: 1500,
      className:classname
    });
  }
}

/**
 * 判断字符串是否为有效的JSON对象字符串
 * @param {string} str 要判断的字符串
 * @returns {boolean} 是否为JSON对象字符串
 */
export function isJsonObjectString(str) {
  if (typeof str !== 'string') return false;

  try {
    const parsed = JSON.parse(str);
    return typeof parsed === 'object' && parsed !== null;
  } catch (error) {
    return false;
  }
}

/**
 * 安全解析JSON字符串，如果不是JSON则返回原字符串
 * @param {string} str 要解析的字符串
 * @returns {object|string} 解析后的对象或原字符串
 */
export function safeJsonParse(str) {
  if (typeof str !== 'string') return str;

  try {
    const parsed = JSON.parse(str);
    return typeof parsed === 'object' && parsed !== null ? parsed : str;
  } catch (error) {
    return str;
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js